import Lazy from './Lazy';

class LazyImg extends Lazy {

    constructor(selector='.lazy-img') {
        super({
            targets: selector,
            loadFn: imgEl => {
                const imgSrc = imgEl.getAttribute('data-lazy');
                if(imgSrc) {
                    const img = document.createElement('img');
                    img.onload = () => {
                        imgEl.src = imgSrc;
                    }
                    img.src = imgSrc;
                }
            },
            threshold: 0.01,
            rootMargin: {top: 0, right: 0, left: 0, bottom: 0},
            persist: false,
            simLoadLimit: 20,
            simLoadDelay: 100,
        })
    }
}

export default LazyImg;
